import * as React from 'react';
import styled from "styled-components"
import { Navigate, useNavigate } from "react-router-dom";
// import { DictioneryPanel } from '../../../Data/DictioneryPanel';
import BoxDesign from '../reports/BoxDesign';
import { useReactToPrint } from "react-to-print";
import { useState } from 'react';
import { apiMain } from '../../App';
import { useEffect } from 'react';
import { GetDataPromise, PostDataPromise } from "../Functions/SendingData";
import Paper from '@mui/material/Paper';
import { MainData } from '../data/MainData';
import img from '../images/Room1.png';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableHead from '@mui/material/TableHead';
import Button from '@mui/material/Button';
import log from '../images/LuxinHotel.png';
import { useRef } from 'react';
import HotelInvoice_Print from './HotelInvoice_Print';
const Styles = styled.div`
  min-height: calc(100svh - 60px);
  display: flex;
  flex-direction: column;
  isolation: isolate;
  position: relative;
  .top-box {
    margin: 1rem 1rem 1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    .row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
    }
    .rowleft {
      /* display:flex; */
      align-items: left;
      justify-content: space-between;
      position: absolute;
      /* padding-left:450px; */
      margin-left:230px;
    }

    .filter-title {
      padding: 1.5rem 2rem;
      font-size: 1.25rem;
      font-weight: 700;
    }
    .expand {
      flex-grow: 1;
    }
    .actions {
      padding: 0 2rem;
      display: flex;
      justify-content: end;
      gap: 0.5rem;
    }
  }
  .filters {
    margin: 0 1rem 1rem;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
    align-items: center;
    position: relative;
    padding: 1.5rem 2rem 0.5rem;
  }
  .table {
    margin: 0 1rem;
    display: grid;
    grid-template-columns:38px repeat(10, 1fr);
    align-items: center;
    position: relative;
    padding: 1rem;
    overflow-x: scroll;
    overflow-y: hidden;
    .top-table {
      grid-column: 11 span;
      display: flex;
      align-items: center;
      margin: 0 0 1rem;
      .expand {
        flex-grow: 1;
      }
      .actions {
        display: flex;
        gap: 0.3rem;
      }
    }
    .printing {
      display: none;
      @media print {
        @page {
          size: 445.5mm 315mm;
          margin: 1.5rem;
          padding: 2px;
        }
      }
    }
    .scroll-body {
      font-size: 0.8rem;
      grid-column: 11 span;
      display: grid;
      grid-template-columns:1fr;
      align-items: center;
      position: relative;
      min-width: 1000px;
      @media print {
        @page {
          size: 445.5mm 315mm;
          margin: 1.5rem;
          padding: 2px;
        }
      }
    }
    .no-match {
      /* grid-column: 13 span; */
    }
    /* .cel {
      border: 1px solid #555555;
      padding: 0.7rem 0.1rem;
      font-size: 0.8rem;
      width: calc(100% - 0.2rem);
      height: calc(100% - 1.4rem);
      align-items: center;
      display: flex;
      justify-content: center;
      &.header {
        font-weight: 700;
        border-bottom: 1px solid var(--n-grey-11);
      }
      &.action {
        display: flex;
        gap: 0.3rem;
        padding: 0 0.25rem;
        width: calc(100% - 0.5rem);
        height: calc(100%);
        grid-column: 2 span;
      }
    } */
  }
  @media screen and (max-width: 850px) {
    padding-bottom: 80px;
    .top-box {
      align-items: flex-start;
      flex-direction: column;
      font-family:'Times New Roman'  !important;
      .filter-title {
        padding: 1.5rem 1rem;
      }
      .actions {
        padding: 0.75rem 1rem;
      }
    }
    .filters {
      padding: 1.5rem 1rem 0.5rem;
      grid-template-columns: repeat(1, 1fr);
      gap: 0.5rem;
    }
  }
`
function createData(name, calories) {
    return { name, calories };
}
export default function HotelInvoice(props) {
    let navigate = useNavigate();
    const componentRef = useRef();
    const print = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: "report passneger from ",
    })
    useEffect(() => {
        getData();
        getDataResturant();
    }, [])
    let today = new Date();
    const [Pass_FName, setPass_FName] = useState("");
    const [Pass_LName, setPass_LName] = useState("");
    const [Room_Number, setRoom_Number] = useState("");
    const [Pass_No, setPass_No] = useState("");
    const [Adults_No, setAdults_No] = useState("");
    const [Checkindate, setCheckindate] = useState("");
    const [Checkoutdate, setCheckoutdate] = useState("");
    const [Data, setData] = useState([]);
    const [DataRest, setDataRest] = useState([]);
    const [Night_No, setNight_No] = useState(0);
    const [Reserv_Price, setReserv_Price] = useState(0);
    const [Balance, setBalance] = useState(0);
    const [Reserv_prepayment, setReserv_prepayment] = useState(0);
    const [Reserv_Extrabed, setReserv_Extrabed] = useState(0);
    const [Reserv_Breakfast, setReserv_Breakfast] = useState(0);
      //  const [Pass_Id, setPass_Id] = useState(0);
    const [Resturant_Date, setResturant_Date] = useState('');
    const [Resturant_Desc, setResturant_Desc] = useState('');
    const [Resturant_Pay, setResturant_Pay] = useState(0);
    const [Rest_Sum, setRest_Sum] = useState(0)
    const getData = async () => {
        let uparams = new URLSearchParams();
         console.log(localStorage.getItem('Reserv_Id'))
        uparams.append("Reserv_Id", localStorage.getItem('Reserv_Id'));
        let res = await GetDataPromise(`${apiMain}/api/v1/reservation/selectreservid?${uparams}`, false);
        let parsed = JSON.parse(res);
               if ((parsed.status && parsed.status !== "error") || parsed.status === "success") {
            let newData = parsed.data;
            setData(newData)
          setCheckindate(newData[0].Reserv_Checkindate)
            setCheckoutdate(newData[0].Reserv_Checkoutdate)
            setPass_FName(newData[0].Pass_FName)
            setPass_LName(newData[0].Pass_LName)
            setRoom_Number(newData[0].Room_Number)
            setPass_No(newData[0].Pass_No)
            setAdults_No(newData[0].Adults_No)
            setNight_No(newData[0].Night_No)
            setReserv_Price(newData[0].Reserv_Price)
            setReserv_prepayment(newData[0].Reserv_prepayment)
            setReserv_Extrabed(newData[0].Reserv_Extrabed)
            setReserv_Breakfast(newData[0].Reserv_Breakfast)
        }
    }
    const getDataResturant = async () => {
        let uparams = new URLSearchParams();
        uparams.append("Reserv_Id", localStorage.getItem('Reserv_Id'));
        let res = await GetDataPromise(`${apiMain}/api/v1/restaurant/selectrestaurant?${uparams}`, false);

        let parsed = JSON.parse(res);
        if ((parsed.status && parsed.status !== "error") || parsed.status === "success") {
            let newDataRest = parsed.data;
            let sum = 0;
            setDataRest(newDataRest);
            // setResturant_Date(newDataRest[0].Resturant_Date)
            // setResturant_Desc(newDataRest[0].Resturant_Desc)
            // setResturant_Pay(newDataRest[0].Resturant_Pay)
            newDataRest.map((row) => (
                sum = sum + row.Resturant_Pay
            ))
            setRest_Sum(sum)
            let b=0
            let c=Reserv_Price
            let d=Reserv_prepayment
            b=sum-d+c
            setBalance(b)

        }
    }
    return (
        <Styles>
          
          <BoxDesign className={"header"}>
          <div style={{ marginLeft: '20px',marginTop:'20px' }} >
            {/* <label style={{ color: 'white', fontSize: '36px', fontFamily: 'Times-Roman' }}>  Luxin Hotel </label> */}
            <img src={log} alt="farazandishan" />
          </div>

          <div style={{marginTop:'20px', borderColor:'gray',border:'solid',borderRadius:'10px', marginRight: 'auto', marginLeft: '20px', backgroundColor: 'gray', width: '300px', height: '50px',display:'inherit' ,float:'left' }} >
            <div>
              <label style={{ fontSize: '26px', color: 'white', fontFamily: 'math !important' }}>  Luxin Hotel </label>

            </div>
            <div style={{fontWeight:'bold', textAlign: 'left', marginTop: '30px', fontSize: '16px', fontFamily: 'math !important' }}>
              Invoice
            </div>

          </div>
          <div className='row' style={{ display: 'inherit', marginRight: '50px',float:'right' }}>
            {/* <img src={log} alt="farazandishan" /> */}
          </div>

        </BoxDesign>

        <BoxDesign className={"top-box"} style={{ fontWeight: 'bold', fontSize: '12px', height: '100px', marginLeft: '20px' }}>
          <div className={'filters'} style={{marginTop:'-20px', textAlign: 'left',display:'inherit',float:'left' }}>
            No:00001

            <div   style={{ marginLeft: '440px',float:'right' ,display:'flex'}} >

              Date:{today.getDate() + '-' + (today.getMonth() + 1) + '-' + today.getFullYear()}
            </div>
          </div>
        
          <div style={{position:'fixed', marginLeft:'40px',marginTop:'30px',display:'inherit',float:'right'}}>

            Addres: 12-4 konstantin Eristavi Dead end , Tbilisi
            <div style={{marginLeft:'250px',display:'inherit',  float: 'right' }} >

              Tel: +995511225552
            </div>
          </div>



        </BoxDesign>
        <BoxDesign className={"top-box"} style={{ height: '140px' }}>
          <div className='rowleft' style={{ marginLeft: '-40px' }}>
            <div className='filter-title' style={{ display: 'flex', marginLeft: '50px' }}>

              <TableContainer component={Table}  >
                <Table size='small' >

                  <TableBody>

                    <TableRow
                      key={1}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell component="th" scope="row" style={{ fontWeight: 'bold', fontSize: '12px', width: '250px' }} >Passenger Name:</TableCell>
                      <TableCell align="left" style={{ fontWeight: 'bold', fontSize: '12px', width: '350px' }}>{Pass_FName + "  " +Pass_LName}</TableCell>
                    </TableRow>
                    <TableRow
                      key={2}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                      <TableCell component="th" scope="row" style={{ fontWeight: 'bold', fontSize: '12px', width: '250px' }} >Check In:</TableCell>
                      <TableCell align="left" style={{ fontWeight: 'bold', fontSize: '12px', width: '350px' }}> {Checkindate.slice(0, 10)}</TableCell>
                    </TableRow>
                    <TableRow
                      key={3}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                      <TableCell component="th" scope="row" style={{ fontWeight: 'bold', fontSize: '12px', width: '150px' }}>Room No:</TableCell>
                      <TableCell align="left" style={{ fontWeight: 'bold', fontSize: '12px' }}>{Room_Number}</TableCell>
                    </TableRow>

                  </TableBody>
                </Table>
              </TableContainer>
              <TableContainer component={Table} style={{ marginLeft: '500px' }}  >
                <Table size='small'  >

                  <TableBody>

                    <TableRow
                      key={1}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell component="th" scope="row" style={{ fontWeight: 'bold', fontSize: '12px' }} >Pass No:</TableCell>
                      <TableCell align="left" style={{ fontWeight: 'bold', fontSize: '12px' }}> {Pass_No}</TableCell>
                    </TableRow>
                    <TableRow
                      key={2}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                      <TableCell component="th" scope="row" style={{ fontWeight: 'bold', fontSize: '12px' }}>Check Out: </TableCell>
                      <TableCell align="left" style={{ fontWeight: 'bold', fontSize: '12px' }}>{Checkoutdate.slice(0, 10)}</TableCell>
                    </TableRow>
                    <TableRow
                      key={3}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                      <TableCell component="th" scope="row" style={{ fontWeight: 'bold', fontSize: '12px' }}>Number of Passenger:</TableCell>
                      <TableCell align="left" style={{ fontWeight: 'bold', fontSize: '12px' }}>{Adults_No}</TableCell>
                    </TableRow>

                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </div>
        </BoxDesign>
        <div style={{ border: 'solid', marginLeft: '10px', marginRight: '10px',marginTop:'20px',height:'450px' }}>
          <div className='title' style={{marginTop:'20px', borderColor:'gray',border:'solid', fontWeight: 'bold', fontSize: '12px', alignContent: 'center', alignItems: 'center', display: 'inherit',marginRight:'10px', marginLeft: '20px', width: 'auto', height: '30px', backgroundColor: '#F2F2F2F2' }}>
            <div style={{ marginLeft: '20px', display: 'inherit', float: 'left' }}>

              No Night: {Night_No}

            </div>
            <div style={{ marginLeft: '150px', display: 'inherit', float: 'left' }}>
              Fee:
            </div>
            <div style={{ marginLeft: '170px', display: 'inherit', float: 'left' }}>
              Currency: USD
            </div>
            <div style={{ marginLeft: '200px' }}>
              Total:
              <div style={{ float: 'right', marginRight: '20px' }}>
                {Reserv_Price}
              </div>
            </div>
          </div>

          <BoxDesign className={"top-box"} style={{ display: 'flex' ,height:'200px'}}>
            <div style={{ marginLeft: '20px', position: 'inherit', float: 'left', marginTop: '20px', textAlign: 'left', width: '900px', height: '240px', fontSize: '16px', fontWeight: 'bold' }}>
              Other Cost:
            </div>
            <div style={{borderColor:'gray',border:'solid',borderRadius:'10px', marginTop: '-130px', marginLeft: '50px', marginRight: '10px', position: 'inherit', float: 'right', alignContent: 'center', textAlign: 'left', width: '210px', height: '30px', fontSize: '12px', fontWeight: 'bold', backgroundColor: '#F2F2F2' }}>
              Extra Bed :
              <div style={{ float: 'right', marginRight: '20px' }}>
                {Reserv_Extrabed}
              </div>

              <div style={{borderColor:'gray',border:'solid',borderRadius:'10px', marginTop: '25px', textAlign: 'left', width: '210px', height: '30px', fontSize: '12px', fontWeight: 'bold', backgroundColor: '#F2F2F2' }}>
                Restaurant  :
                <div style={{ float: 'right', marginRight: '20px' }}>
                  {Rest_Sum}
                </div>
              </div>
              <div style={{ borderColor:'gray',border:'solid',borderRadius:'10px',marginTop: '5px', textAlign: 'left', width: '210px', height: '30px', fontSize: '12px', fontWeight: 'bold', backgroundColor: '#F2F2F2' }}>
                Breakfast  :
                <div style={{ float: 'right', marginRight: '20px' }}>
                  {Reserv_Breakfast}
                </div>

              </div>
              <div style={{ borderColor:'gray',border:'solid',borderRadius:'10px',marginTop: '5px', textAlign: 'left', width: '210px', height: '30px', fontSize: '12px', fontWeight: 'bold', backgroundColor: '#F2F2F2', display: 'flex' }}>
                Other  :
                <div  >

                </div>

              </div>
            </div>

          </BoxDesign>

          <div className='title' style={{borderColor:'gray',border:'solid',  fontWeight: 'bold', fontSize: '12px', alignContent: 'center', alignItems: 'center', display: 'inherit',marginRight:'10px', marginLeft: '20px', width: 'auto', height: '30px', backgroundColor: '#F2F2F2F2' }}>
            <div style={{ marginLeft: '20px', display: 'inherit', float: 'left' }}>
              SUM:
            </div>
            <div style={{ display: 'inherit', float: 'right', marginRight: '20px' }}>
              {Rest_Sum}
            </div>


          </div>

          <BoxDesign className={"top-box"} style={{ borderColor:'gray',border:'solid',borderRadius:'10px', float: 'right',marginTop:'7px',marginRight:'10px', position: 'flex' }}>

            <div className='title' style={{ textAlign: 'left', fontWeight:'bold', fontSize: '12px', alignContent: 'center', width: '210px', height: '30px', backgroundColor: '#F2F2F2F2' }} >
              Advance Payment         :
              <div style={{ display: 'inherit', float: 'right', marginRight: '20px' }}>

                {Rest_Sum}
              </div>
            </div>
              </BoxDesign>
          
        

          {/* <div className='title' style={{ alignItems: 'center', marginLeft: '20px', width: 'auto', height: '50px', backgroundColor: '#F2F2F2F2', border: 'solid' }}> */}
          <div className='title' style={{borderColor:'gray',border:'solid' , marginTop: '50px', fontWeight: 'bold', fontSize: '12px',marginRight:'10px',  marginLeft: '20px',width:'auto', height: '30px', backgroundColor: '#F2F2F2F2' }}>
            <div style={{ marginLeft: '20px',textAlign:'left'}}>

              Balance Payable:
           
            <div style={{ marginRight: '-210px',float:'right' }}>
              {Balance}
            </div>
 </div>
          </div>
          
        </div>
        <br>
        </br>
        <br></br>
        {/* <BoxDesign className={"top-box"}> */}

        <div className='title' style={{  fontSize: '14px', fontWeight: 'bold', textAlign: 'left' , marginLeft: '20px'}} >
            Thank you for your warm presence . We hope to see you again.
          
          </div>
          <br>
        </br>
        <br></br>
          <div className='title' style={{ display:'flex', fontSize: '14px', fontWeight: 'bold', marginLeft: '20px' }} >
            Manager Hotel.
          </div>
        {/* </BoxDesign> */}
        <Button onClick={()=>{print()}} variant="contained">Print</Button>
               
               <div   style={{display:'none'}}> 
                      <div className='printing' ref={componentRef}>
                         <HotelInvoice_Print 
                         datas={Data}
                         FName={Pass_FName}
                         LName={Pass_LName}
                         Checkindate={Checkindate}
                         Checkoutdate={Checkoutdate}
                         Room_Number={Room_Number}
                         Pass_No={Pass_No}
                         Adults_No={Adults_No}
                         Night_No={Night_No}
                         Reserv_Price={Reserv_Price}
                         Reserv_Extrabed={Reserv_Extrabed}
                         Rest_Sum={Rest_Sum}
                         Reserv_Breakfast={Reserv_Breakfast}
                         Balance={Balance}
                         />
                
                       </div>
              </div>
        <br>
        </br>
        <br></br>
        <br></br>
        <br></br>
  
        </Styles>


    )
}